import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { DragLayer } from 'react-dnd';
import { useIntl } from 'react-intl';

import { thumbnailPlaceholder } from '../helpers/Collections';
import ItemTypes from '../helpers/DNDItemTypes';

const getItemStyles = (props) => {
  const {
    initialOffset,
    currentOffset,
    offsets,
    isDragging,
  } = props;

  if (!isDragging || !initialOffset || !currentOffset) {
    return {
      display: 'none',
    };
  }

  if (!initialOffset || !currentOffset) {
    return {};
  }

  const { x, y } = currentOffset;
  const transform = `translate(${x - offsets.x}px, ${y - (offsets.y - 20)}px)`;
  return {
    transform,
    WebkitTransform: transform,
  };
};

const CustomDragLayer = ({
  isDragging,
  itemType,
  item,
  selectedFiles,
  selectedCollections,
  files,
  collections,
  ...props
}) => {
  const intl = useIntl();
  const [thumbnail, setThumbnail] = useState(null);
  const [offsets, setOffsets] = useState({ x: 0, y: 0 });

  useEffect(() => {
    if (item) {
      let thumbnailSrc = null;
      if (itemType === ItemTypes.FILE) {
        const file = files.find(f => (f.uuid === item.id));
        if (file) {
          thumbnailSrc = file.urls.thumbnail;
        }
      }
      if (itemType === ItemTypes.COLLECTION) {
        const collection = collections.find(c => (c.uuid === item.id));
        if (collection && collection.featured_file) {
          thumbnailSrc = collection.featured_file.urls.thumbnail;
        } else {
          thumbnailSrc = thumbnailPlaceholder;
        }
      }
      setThumbnail(thumbnailSrc);
      setOffsets({
        x: parseInt(window.jQuery('nav.sidebar').outerWidth()),
        y: parseInt(window.jQuery('div.toolbar').outerHeight()),
      });
    }
  }, [item, itemType, files, collections]);

  if (!isDragging) {
    return null;
  }

  if (![ItemTypes.FILE, ItemTypes.COLLECTION].includes(itemType)) {
    return null;
  }

  const titleElements = [];
  if (selectedFiles.length > 0) {
    titleElements.push(intl.formatMessage({ defaultMessage: 'Files: {files}' }, { files: selectedFiles.length }));
  }
  if (selectedCollections.length > 0) {
    titleElements.push(intl.formatMessage({ defaultMessage: 'Collections: {collections}' }, { collections: selectedCollections.length }));
  }

  return (
    <div id="drag-layer" style={getItemStyles({ isDragging, offsets, ...props })}>
      {titleElements.length > 0 && (
        <div className="drag-layer-title">
          {titleElements.join(', ')}
        </div>
      )}
      {thumbnail && (
        <img src={thumbnail} alt="" />
      )}
    </div>
  );
};

const collect = monitor => ({
  item: monitor.getItem(),
  itemType: monitor.getItemType(),
  initialOffset: monitor.getInitialSourceClientOffset(),
  currentOffset: monitor.getClientOffset(),
  isDragging: monitor.isDragging(),
});

const mapStateToProps = state => ({
  files: state.Files.files,
  collections: state.Collections.collections,
  selectedFiles: state.Files.selectedFiles,
  selectedCollections: state.Collections.selectedCollections,
});

CustomDragLayer.propTypes = {
  isDragging: PropTypes.bool.isRequired,
  itemType: PropTypes.string,
  item: PropTypes.object,
  files: PropTypes.array.isRequired,
  collections: PropTypes.array.isRequired,
  selectedFiles: PropTypes.array.isRequired,
  selectedCollections: PropTypes.array.isRequired,
};

CustomDragLayer.defaultProps = {
  itemType: null,
  item: null,
};

export default connect(mapStateToProps)(DragLayer(collect)(CustomDragLayer));
